import PortalAccess from "./PortalAccess";
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ allowedRoles }) => {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a more sophisticated loading spinner
  }

  if (!user) {
    // Not authenticated, redirect to login page
    return <Navigate to="/auth" replace state={{ from: location.pathname + (location.search || '') + (location.hash || ''), returnState: location.state }} />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Authenticated but not authorized, redirect to an unauthorized page or home
    return <PortalAccess />; // Or /unauthorized
  }

  return <Outlet />;
};

export default PrivateRoute;
